import { createStoreModule } from '@/_core/fluxstore';
import type { IAction } from '@/_core/fluxstore/types';
import { BoardActivityPanelState } from './types';

const initState = () => new BoardActivityPanelState();

export const useBoardActivityStore = createStoreModule<BoardActivityPanelState, IAction<BoardActivityPanelState>>(
    initState, 'boardActivity'
);
